export default "__VITE_PUBLIC_ASSET__942101b7__"